module.exports = __webpack_public_path__ + "static/img/2997_phase_function_Paper_Points.accf672.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2997_phase_function_Paper_Points.png
// module id = H6KH
// module chunks = 0